var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('page-header',{attrs:{"title":'Contact Us',"image":'contactUs_hero_wGradient.png'}}),_c('page-content',[_vm._v("\n    Hello Contact\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }